// assets
import { IconContract, IconList } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconAgreementGrievance: IconContract,
  IconConsentList: IconList
};

// ==============================|| MENU ITEMS - CONSENT MASTER ||============================== //

const consentMaster: NavItemType = {
  id: 'consent-master',
  title: 'Consent Master',
  type: 'group',
  icon: icons.IconAgreementGrievance,
  children: [
    {
      id: 'consent-master-list',
      title: 'All Consents',
      type: 'item',
      url: '/consent-master/list',
      icon: icons.IconConsentList,
      breadcrumbs: false
    }
  ]
};

export default consentMaster;